export const SCROLL_TO_EVENT_KEY = 'scrollToHotelInfoSection';
